import React, {useCallback, useState} from "react"
import {ProfileDB} from "../../../models/ProfileDB.model"
import {Collaborator, RepoDB} from "../../../models/RepoDB.model"
import Tags from "../../App/Tags"
import styles from "./index.module.scss"
import solanaImg from "../../../assets/profile/solana_small.png"

interface RepoDescriptionProps {
  repoDB: RepoDB
  repoUrl: string
}

export const RepoDescription = (props: RepoDescriptionProps) => {
  const {repoDB, repoUrl} = props
  const [isUrlCopied, setUrlCopied] = useState(false)

  const description = repoDB.get("description") || ""
  const collaborators = repoDB.get("collaborators") || []

  const onCopyUrl = useCallback(async () => {
    await navigator.clipboard.writeText(repoUrl)
    setUrlCopied(true)
  }, [])

  const tags = repoDB.get("tags") || []

  return (
    <div className={styles.InfoContainer}>
      <div className={styles.InfoHeader}>
        Clone the repo
      </div>

      <div className={styles.RepoUrlContainer}>
        <div className={styles.RepoUrlText}>
          {repoUrl}
        </div>
        <button
          onClick={onCopyUrl}
          className={styles.CopyButton}
        >
          {isUrlCopied ? "COPIED!" : "COPY"}
        </button>
      </div>

      <div className={styles.InfoHeader}>
        About the repo
      </div>

      <div className={styles.InfoDesc}>
        {description}
      </div>

      {
        tags.length > 0
          ? <Tags
            tags={repoDB.get("tags") ?? []}
            flexDirection="col"
          />
          : null
      }

      <div className={styles.InfoHeader}>
        Team ( {collaborators.length} )
      </div>

      <div className={styles.InfoTeamContainer}>
        {
          collaborators.map((c: Collaborator) => {
            const pubKey = c.userID.split("-")[3]
            const truncPubKey = pubKey.slice(0, 6) + "..." + pubKey.slice(-4)

            return (
              <div className={styles.InfoTeam} key={c.userID}>
                <div>@{c.name}</div>
                <div className={styles.PubKey}>
                  <img src={solanaImg} alt="solana"/>
                  <div>{truncPubKey}</div>
                </div>
              </div>
            )
          })
        }
      </div>

    </div>
  )
}
